import { getHabihubBrandColors } from 'config';
import useAuth from './useAuth';

const useHabihubBrandColors = () => {
  const { user } = useAuth();
  return getHabihubBrandColors(user?.id);
};

export default useHabihubBrandColors;
